import React, { useState, useEffect } from 'react';
import './Dashboard2.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import baseURL from '../../Components/url';

export default function Dashboard2() {
    const [stats, setStats] = useState({
        totalRifas: 0,
        totalNumeros: 0,
        totalUsuarios: 0,
        totalGanadores: 0,
        totalReservados: 0,
        totalPendientes: 0,
        totalDisponibles: 0
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadDashboardData();
    }, []);

    const loadDashboardData = async () => {
        try {
            setLoading(true);
            setError(null);
            
            // Cargar todos los datos en paralelo con manejo individual de errores
            const fetchWithFallback = async (url, defaultData) => {
                try {
                    const response = await fetch(url);
                    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                    const data = await response.json();
                    return data;
                } catch (error) {
                    console.warn(`Error fetching ${url}:`, error);
                    return defaultData;
                }
            };

            const [rifasRes, numerosCountRes, usuariosRes, ganadoresRes] = await Promise.all([
                fetchWithFallback(`${baseURL}/rifaGet.php`, { rifas: [] }),
                fetchWithFallback(`${baseURL}/numeroGetCounts.php`, { counts: { reservado: 0, pendiente: 0, disponible: 0, total: 0 } }),
                fetchWithFallback(`${baseURL}/usuariosGet.php`, { usuarios: [] }),
                fetchWithFallback(`${baseURL}/ganadorGet.php`, { ganadores: [] })
            ]);

            // Validar y establecer estadísticas con valores por defecto
            setStats({
                totalRifas: Array.isArray(rifasRes?.rifas) ? rifasRes.rifas.length : 0,
                totalUsuarios: Array.isArray(usuariosRes?.usuarios) ? usuariosRes.usuarios.length : 0,
                totalGanadores: Array.isArray(ganadoresRes?.ganadores) ? ganadoresRes.ganadores.length : 0,
                totalReservados: numerosCountRes?.counts?.reservado || 0,
                totalPendientes: numerosCountRes?.counts?.pendiente || 0,
                totalDisponibles: numerosCountRes?.counts?.disponible || 0,
                totalNumeros: numerosCountRes?.counts?.total || 0
            });

            setLoading(false);
        } catch (error) {
            console.error('Error loading dashboard data:', error);
            setError('Error al cargar los datos del dashboard');
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className='containerGrid'>
                <Header />
                <section className='containerSection'>
                    <HeaderDash />
                    <div className='container'>
                        <div className='dashboard2-loading'>
                            <p>Cargando datos...</p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    if (error) {
        return (
            <div className='containerGrid'>
                <Header />
                <section className='containerSection'>
                    <HeaderDash />
                    <div className='container'>
                        <div className='dashboard2-error'>
                            <p>{error}</p>
                            <button onClick={loadDashboardData}>Reintentar</button>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <div className='dashboard2-container'>
                        <h1 className='dashboard2-title'>Dashboard</h1>
                        
                        <div className='dashboard2-grid'>
                            <div className='dashboard2-card'>
                                <h3>Total de Rifas</h3>
                                <p className='dashboard2-number'>{stats.totalRifas || 0}</p>
                            </div>

                            <div className='dashboard2-card'>
                                <h3>Total de Números</h3>
                                <p className='dashboard2-number'>{stats.totalNumeros || 0}</p>
                            </div>

                            <div className='dashboard2-card'>
                                <h3>Total de Usuarios</h3>
                                <p className='dashboard2-number'>{stats.totalUsuarios || 0}</p>
                            </div>

                            <div className='dashboard2-card'>
                                <h3>Total de Ganadores</h3>
                                <p className='dashboard2-number'>{stats.totalGanadores || 0}</p>
                            </div>

                            <div className='dashboard2-card'>
                                <h3>Números Reservados</h3>
                                <p className='dashboard2-number'>{stats.totalReservados || 0}</p>
                            </div>

                            <div className='dashboard2-card'>
                                <h3>Números Pendientes</h3>
                                <p className='dashboard2-number'>{stats.totalPendientes || 0}</p>
                            </div>

                            <div className='dashboard2-card'>
                                <h3>Números Disponibles</h3>
                                <p className='dashboard2-number'>{stats.totalDisponibles || 0}</p>
                            </div>

                            <div className='dashboard2-card'>
                                <h3>Total Vendidos</h3>
                                <p className='dashboard2-number'>{(stats.totalReservados || 0) + (stats.totalPendientes || 0)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
